module.exports = __webpack_public_path__ + "static/media/KWSP.0fe2b72e.png";